import axiosServices from 'utils/axios';
import type { AxiosResponse } from 'axios';

/**
 * NEX-1645 (plan 2026-10-20, Tarea 3.3) — `GET /app/features` (nexvia-api-web `app-config.routes.ts`):
 * public, no auth, inside the `{ success, data }` envelope (contracts/app-features.ts). The app-wide
 * switches the backoffice turns on and off; today only the storage module's state.
 *
 * In shared/ (AGENTS.md §2) because several features and the layout read it: the shipments wizard, the
 * storage feature and layout/AppLayout.tsx.
 */
export const getAppFeatures = (): Promise<AxiosResponse<unknown>> => axiosServices.get('/app/features');
